module.exports = __webpack_public_path__ + "static/card_payments-fcbf47dff34af5ffa24a471ce2f11b3e.png";